module.exports = __webpack_public_path__ + "img/31474c1e375ddba642c949b3018b1f91.61c24b2f.jpg";